<button
  [ngClass]="{
    'bg-red-orange border-transparent': type === buttonTypesEnum.PRIMARY,
    'bg-transparent border-red-orange' : type === buttonTypesEnum.SECONDARY,
    'bg-transparent border-white' : type === buttonTypesEnum.TERTIARY
  }"
  [disabled]="disabled"
  (click)="emitClick()"
  type="button"
  class="
    border-2
    rounded-8
    px-16
    py-8
    rounded
    transition
    w-full
  "
>
  <span
    [ngClass]="{
      'text-white': type === buttonTypesEnum.PRIMARY || buttonTypesEnum.TERTIARY,
      'text-red-orange' : type === buttonTypesEnum.SECONDARY,
    }"
    class="strong"
  >
    {{ text }}
  </span>
</button>
